import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import {
  DialogTypeEnum,
  IDialogCommissionData,
  IDialogConfirm
} from 'src/app/models/dialog';
import {
  ICommissionInfo,
  IParametersCommission,
  IProductCommission
} from './../../../models/commission';
import { ApiCommissionService } from 'src/app/services/api/api-commission.service';
import { SnackbarService } from './../../../services/snackbar.service';
import { ActionEnum } from './../../../models/generic';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-comissao-card',
  templateUrl: './comissao-card.component.html',
  styleUrls: ['./comissao-card.component.scss']
})
export class ComissaoCardComponent implements OnInit, OnChanges {
  @Input() commission!: ICommissionInfo;
  @Input() parametersCommission!: IParametersCommission;

  productsInfo: { [key: string]: string | number }[] = [];

  commissionDialogTitle: { [key: string]: string } = {
    view: 'Visualizar Comissão de Faturamento',
    edit: 'Editar Comissão de Faturamento'
  };

  constructor(
    private _dialogService: ApiDialogService,
    private _commissionService: ApiCommissionService,
    private _snackbarService: SnackbarService
  ) {}

  Action = ActionEnum;

  ngOnInit(): void {
    this.getNameProducts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['commission'] || changes['parametersCommission']) {
      this.getNameProducts();
    }
  }

  getNameProducts(): void {
    if (!this.commission || !this.parametersCommission?.ProductsName?.length) {
      this.productsInfo = [];
      return;
    }

    this.productsInfo = this.parametersCommission?.ProductsName
      .map((product) => ({
        name: product.Name,
        value: this.getProductSummary(product)
      }))
      .filter((product) => !!product.value);
  }

  getValueProductDefault(product: IProductCommission): string | number {
    return (
      this.commission.ProductsInfos.find((info) => info.Name === product.Name)?.Infos[0]?.Percentage || ''
    );
  }

  getValueProductInvoice(product: IProductCommission): string | number {
    return (
      this.commission.ProductsInfos.find((info) => info.Name === product.Name)?.Infos[0]?.InvoiceValue || ''
    );
  }

  getProductSummary(product: IProductCommission): string {
    const productInfo = this.commission.ProductsInfos.find(
      (info) => info.Name === product.Name
    )?.Infos[0];

    if (!productInfo) {
      return '';
    }

    if (this.isFixedProduct(productInfo)) {
      const fixedSummary: string[] = [];

      if (productInfo.InvoiceValue != null) {
        fixedSummary.push(` ${this.formatCurrency(productInfo.InvoiceValue)}`);
      }

      // if (productInfo.TransferValue != null) {
      //   fixedSummary.push(`Rep. ${this.formatCurrency(productInfo.TransferValue)}`);
      // }

      return `Fixa - ${fixedSummary.join(' | ')}`;
    }

    return productInfo.Percentage != null ? `Variavel - ${productInfo.Percentage}%` : '';
  }

  isFixedProduct(productInfo: ICommissionInfo['ProductsInfos'][number]['Infos'][number]): boolean {
    return productInfo.InvoiceValue != null || productInfo.TransferValue != null;
  }

  formatCurrency(value: string | number): string {
    const currencyPipe = new CurrencyPipe('pt-BR', 'R$');

    return currencyPipe.transform(value) ?? 'R$ 0,00';
  }

  handlerDeleteCommission(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Excluir comissão',
        title: `Tem certeza que deseja excluir essa Comissão (Cód. ${this.commission.Code})?`,
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) this.deleteCommission();
    });
  }

  deleteCommission(): void {
    this._commissionService
      .deleteCommission(this.commission.ComissionId)
      .subscribe((response) => {
        this._snackbarService.openSnackBar(
          'Comissão excluída com sucesso!',
          'success'
        );

        this._commissionService.listCommissionsEvent.next(true);
      });
  }

  openDialogCommission(type: string): void {
    const dataDialog: IDialogCommissionData = {
      type,
      template: {
        title: this.commissionDialogTitle[type],
        parameters: this.parametersCommission,
        commissionCardId: this.commission.ComissionId
      }
    };

    this._dialogService.openDialogComission(dataDialog).then((response) => {});
  }
}
